<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="card vx-card">
            <div class="card-header bg-white">
              <h4 class="card-title">
                <strong>
                 Información Inventario
                </strong>
                
                <span class="float-right">
                  <i class="fa fa-calendar text-primary"></i>
                  {{ new Date() | moment("DD/MM/YYYY hh:mm a") }}
                </span>
              </h4>
            </div>

            <div class="card-body">
              <!-- add items -->
              <add-items-inventory
                :items="items"
                :type="'invoice'"
                :preselect_client="preselect_client"
              >
              </add-items-inventory>
              <!-- end add items -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import itemsService from "../../services/items.service";
import AddItemsInventory from "@/components/AddItemsInventory.vue";
import { mapState } from "vuex";

export default {
  name: "new-inventory",
  components: {
    AddItemsInventory
  },
  data() {
    return {
      items: []
    };
  },
  computed: {
    ...mapState(["tax_types", "selected_items"]),
    preselect_client() {
      return this.$route.query.id;
    }
  },
  methods: {
    getItemProducts(page = 0, search = {}) {
      itemsService.getItemProducts(page, search).then(res => {
        this.items = res.data;
      }).catch(error => {
        if(error.response.status == 401) {
          // localStorage.clear();
          // this.$router.push('login');
        }
      })
    },
  },
  created() {
    this.getItemProducts();
  }
};
</script>

<style scoped>
.form-group label {
  font-weight: bold;
}
</style>
